/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */

/**
 * The contract type
 */
export type ContractType = (typeof ContractType)[keyof typeof ContractType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractType = {
  distribution: "distribution",
  neighbouring_rights: "neighbouring_rights",
} as const;
